import * as React from "react";
import { Button, capitalizeFirstLetter } from "@vebox/etui-core";
import { LoadingButton } from "../../../../../components/buttons/LoadingButton";
import { Display } from "../../../../../components/Display";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";
import { DownloadCSV } from "../../widgets/DownloadCSV";

declare var AppTranslations: AppTranslations;

interface FormCardFooterWithExportProps {
	onReset?: () => void;
	onNext: () => void;
	nextButtonText?: string;
	restButtonText?: string;
	disabled?: boolean;
	disabledCancel?: boolean;
	loadable?: boolean;
	loading?: boolean;
	rootDivStyle?: React.CSSProperties;
	canExport?: boolean;
	entriesToExport?: any;
}

export const FormCardFooterWithExport: React.FC<
	FormCardFooterWithExportProps
> = ({
	canExport,
	disabledCancel,
	disabled,
	loading,
	nextButtonText,
	onNext,
	restButtonText,
	onReset,
	rootDivStyle,
	loadable,
	entriesToExport,
}) => {
	return (
		<div
			className={"form-card-footer flx-row flx-space-between"}
			style={rootDivStyle}
		>
			<div className={"flx-row"}>
				<Display isVisible={canExport}>
					<DownloadCSV
						fileName={"invalid_equipment_list"}
						data={entriesToExport}
					/>
				</Display>
			</div>
			<div className={"flx-row"}>
				<Display isVisible={onReset}>
					<Button
						variant={"tertiary"}
						onClick={onReset}
						disabled={disabledCancel}
					>
						{capitalizeFirstLetter(
							restButtonText ?? AppTranslations.userCreationProcess.reset,
						)}
					</Button>
				</Display>
				{loadable ? (
					<LoadingButton
						variant={"strong"}
						onClick={onNext}
						disabled={disabled}
						loading={loading}
					>
						{capitalizeFirstLetter(
							nextButtonText ?? AppTranslations.userCreationProcess.next,
						)}
					</LoadingButton>
				) : (
					<Button variant={"strong"} onClick={onNext} disabled={disabled}>
						{capitalizeFirstLetter(
							nextButtonText ?? AppTranslations.userCreationProcess.next,
						)}
					</Button>
				)}
			</div>
		</div>
	);
};
